var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-bg"},[_c('div',{attrs:{"id":"lottie"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../../static/image/live-logo.png"),"rel":"preload","mode":"widthFix"},on:{"click":function($event){return _vm.onLoadingLogin()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }